/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Components imports
import { Table, Typography } from 'antd';

// Misc imports
import { getCurrentQueryState } from '../../../store/utils/getCurrentQueryState';
import { useBotLanguage } from '../../../utils/hooks/useBotLanguage';
import { NAV_BOT } from '../../../constants/navigation';
import { truncate } from '../../../utils/string/truncate';
import replaceUrlParams from '../../../utils/string/replaceUrlParams';

const IntentsResultsTable = ({ runTestSetResults }) => {
  const { t } = useTranslation();
  const { orgId, tenantId } = useParams();
  const { data: automatedAnswers, isFetching: isFetchingAutomatedAnswers } = getCurrentQueryState('fetchAutomatedAnswers', { orgId, tenantId });
  const { currentBotLanguage, primaryBotLanguage } = useBotLanguage();

  const columns = [
    {
      title: t('User Input'),
      dataIndex: 'input',
      width: '30%'
    },
    {
      title: t('Expected Result'),
      dataIndex: 'expectedIntentId',
      render: (_text, record) => {
        const matchedAnswer = automatedAnswers?.items?.find(answer => answer?.id === record.expectedIntentId) || null;
        return (
          <Fragment>
            <Typography.Link
              type="link"
              className="px-0"
              disabled={!matchedAnswer}
              onClick={() => {
                window.open(`${replaceUrlParams(NAV_BOT, { orgId, tenantId })}?view=behavior&tab=automated-answers&edit=${matchedAnswer.id}`, '_blank ');
              }}
            >
              {truncate(`${matchedAnswer?.name[currentBotLanguage] || matchedAnswer?.name[primaryBotLanguage] || record?.expectedIntentId }`, 45, '...')}
            </Typography.Link>
          </Fragment>
        );
      }
    },
    {
      title: t('Detected Automated Answer'),
      dataIndex: 'detectedIntentId',
      align: 'center',
      render: (_text, record) => {
        const matchedAnswer = automatedAnswers?.items?.find(answer => answer?.id === record.detectedIntentId) || null;
        return (
          <Fragment>
            <Typography.Link
              className="px-0"
              danger={record.expectedIntentId !== record.detectedIntentId}
              disabled={!matchedAnswer}
              onClick={() => {
                window.open(`${replaceUrlParams(NAV_BOT, { orgId, tenantId })}?view=behavior&tab=automated-answers&edit=${matchedAnswer?.id}`, '_blank ');
              }}
            >
              {truncate(`${matchedAnswer?.name[currentBotLanguage] || matchedAnswer?.name[primaryBotLanguage] || record?.detectedIntentId }`, 30, '...')}
            </Typography.Link>&nbsp;
            {record.detectedIntentScore !== null ? `- ${record.detectedIntentScore?.toFixed(2)}` : null}
          </Fragment>
        );
      }
    }
  ];

  return (
    <Table
      size="small"
      dataSource={runTestSetResults?.messageResults?.filter(result => result?.detectedIntentId !== result?.expectedIntentId) || []}
      columns={columns}
      loading={isFetchingAutomatedAnswers}
      pagination={{
        size: 'default',
        showTotal: (total) => `${t('Total Results')}: ${total}`
      }}
    />
  );
};

IntentsResultsTable.propTypes = {
  runTestSetResults: PropTypes.array
};

export default IntentsResultsTable;
